import { PATH_NAME } from 'configs/pathName';
import { useGlobalContext } from 'context/GlobalContext';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function GuestGuard() {
  const { user } = useGlobalContext();
  const username = user.username;

  const isAuth = !!user.userId;

  if (isAuth) return <Navigate to={PATH_NAME.ROOT} />;
  if (username) return <Navigate to={PATH_NAME.SELECT_METHOD} />

  return <Outlet />;
}

export default GuestGuard;